import { useEffect, useState } from "react";

import { SingleStepDialog } from "components/SingleStepDialog";
import { Source } from "interfaces";
import { FileDetailRow } from "../../shared/FileDetailRow";
import { ActionDetailSource } from "./components/ActionDetailSource";
import { HeaderDetailSource } from "./components/HeaderDetailSource";
import { FooterDetailSource } from "./components/FooterDetailSource";

export const ModalDetailSourceProject = ({
  showDialog = false,
  source,
  onClose,
  items,
}: {
  showDialog: boolean;
  source: Source;
  onClose: Function;
  items: any;
}) => {
  const [visible, setVisible] = useState(showDialog);

  const handleDismiss = () => {
    setVisible(false);
    onClose();
  };
  useEffect(() => {
    setVisible(showDialog);
  }, [showDialog]);

  return (
    <SingleStepDialog
      onHideCallback={handleDismiss}
      height="auto"
      width="700px"
      header={<HeaderDetailSource source={source} />}
      body={<FileDetailRow source={source} />}
      footer={<FooterDetailSource sourceAddedBy={source.addedBy} />}
      display={visible}
      action={<ActionDetailSource items={items} />}
      setVisible={setVisible}
      customClass="custom-dialog-detail-project"
    />
  );
};
